import React from 'react';
import { Link } from 'react-router-dom';
import PublicNavbar from '../../components/PublicNavbar';

const LGPDRights = () => {
  return (
    <>
      <PublicNavbar />
      <div className="min-h-screen bg-gradient-to-br from-purple-50 to-pink-50 py-12 px-4">
        <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-6">Seus Direitos (LGPD)</h1>
          
          <div className="space-y-6 text-gray-600">
            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">Seus Direitos Garantidos pela LGPD</h2>
              <p>De acordo com a Lei Geral de Proteção de Dados, você tem os seguintes direitos:</p>
              
              <div className="mt-4 space-y-4">
                <div className="p-4 bg-purple-50 rounded-lg">
                  <h3 className="font-semibold text-purple-700">1. Direito de Acesso</h3>
                  <p className="mt-2">Você pode solicitar acesso a todos os seus dados pessoais que mantemos.</p>
                </div>

                <div className="p-4 bg-purple-50 rounded-lg">
                  <h3 className="font-semibold text-purple-700">2. Direito de Correção</h3>
                  <p className="mt-2">Pode solicitar a correção de dados incompletos, inexatos ou desatualizados.</p>
                </div>

                <div className="p-4 bg-purple-50 rounded-lg">
                  <h3 className="font-semibold text-purple-700">3. Direito de Exclusão</h3>
                  <p className="mt-2">Pode solicitar a exclusão de seus dados pessoais de nossa base.</p>
                </div>

                <div className="p-4 bg-purple-50 rounded-lg">
                  <h3 className="font-semibold text-purple-700">4. Direito de Portabilidade</h3>
                  <p className="mt-2">Pode solicitar a transferência de seus dados para outro serviço.</p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">Como Exercer seus Direitos</h2>
              <p>Para exercer qualquer um desses direitos, você pode:</p>
              <ul className="list-disc pl-6 mt-2">
                <li>Enviar um e-mail para: lgpd@mapasastrais.com</li>
                <li>Acessar seu painel de controle de privacidade</li>
                <li>Entrar em contato com nosso DPO (Data Protection Officer)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">Prazo de Resposta</h2>
              <p>Responderemos a sua solicitação em até 15 dias úteis.</p>
            </section>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <Link 
              to="/"
              className="text-purple-600 hover:text-purple-700 font-medium"
            >
              ← Voltar para a página inicial
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default LGPDRights;
